import types from './types';
import create from '~/misc/create';

import get from 'lodash/get';
import HTTPError from '~/misc/HTTPError';
import {promiseAction, ActionError} from '~/misc/dispatch';
import * as api from './api';

export const initAccountLevel = (dispatch) => dispatch(create(types.ACCOUNT_INIT, {accountLevel: null}));

export const initAccountInfo = (dispatch) => dispatch(create(types.ACCOUNT_INFO_INIT, {}));

export const getAccount = (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.ACCOUNT_UPDATE,
  api.getMsgFromAccount(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);





// WEBPACK FOOTER //
// ./src/modules/account/actions.js